import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { Modal, ModalHeader, ModalBody, ModalFooter, Row, Col } from "reactstrap";
import { toast } from "react-toastify";

import { Formik, Field } from "formik";
import * as Yup from "yup";
import isEmpty from "lodash/isEmpty";
import get from "lodash/get";

import getImage from "helpers/getImage";
import { FormElements, Preloader } from "components";

import * as routines from "../routines";

const TRANSLATION_BASE = "modules.category";

export default ({ isOpen = false, parent = {}, data = {}, onClose = () => {} }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const image = useSelector(state => state.Category.image);

  const isSubcategory = !isEmpty(parent);
  const isNew = isEmpty(data);

  let title = "";

  const lang = [
    { "id": 1, "name": "uz" },
    { "id": 2, "name": "ru" },
  ];

  if (isNew && isSubcategory) {
    title = `${t(`${TRANSLATION_BASE}.new_subcategory`)} (${parent.name})`;
  } else if (isNew && !isSubcategory) {
    title = t(`${TRANSLATION_BASE}.new_category`);
  } else if (!isNew && isSubcategory) {
    title = `${t(`${TRANSLATION_BASE}.edit_subcategory`)} (${parent.name})`;
  } else {
    title = t(`${TRANSLATION_BASE}.edit_category`);
  }

  return (
    <Modal isOpen={isOpen}>
      <Formik
        enableReinitialize
        initialValues={{
          parent_id: parent.id || 0,
          name: data.name,
          price: data.price,
          discount: data.discount,
          image: data.image || "/categories/czzR5lwljAdyOZrSrT5jSX47GPzCkAXMGUi3frPG.png",
          thumbnail: data.thumbnail || "/categories/thumbnails/czzR5lwljAdyOZrSrT5jSX47GPzCkAXMGUi3frPG.png",
          description: data.description
        }}
        validationSchema={() => {
          let schema = {
            name: Yup.string().required(t("global.validation.field_is_required"))
            // image: Yup.string()
          };

          if (isEmpty(parent) && isEmpty(data)) {
            schema["image"] = Yup.string().required(t("global.validation.field_is_required"));
          }

          return Yup.object().shape(schema);
        }}
        onSubmit={(values, { setSubmitting }) => {
          let _values = values;

          if (isEmpty(parent) && data) {
            _values = {
              ...values
              // image: values?.image || data?.image,
              // thumbnail: values?.thumbnail || data?.thumbnail
            };
          }

          const options = {
            category_id: data.id,
            values: _values,
            onSuccess: () => {
              setSubmitting(false);
              toast.success(t("global.notification.success"), {
                position: toast.POSITION.TOP_RIGHT
              });
              onClose();
            },
            onError: (error = {}) => {
              setSubmitting(false);
              toast.error(t("global.error_occurred"), {
                position: toast.POSITION.TOP_RIGHT
              });
            }
          };

          dispatch(isNew ? routines.create(options) : routines.update(options));
        }}>
        {({ errors, isSubmitting, setFieldValue, handleSubmit }) => {
          return (
            <Preloader loading={isSubmitting}>
              <form onSubmit={handleSubmit}>
                <ModalHeader toggle={onClose}>{title}</ModalHeader>
                <ModalBody className="p-4">
                  <Row>
                    <Col md={12}>
                      <Field
                        name="lang"
                        label={t(`global.lang`)}
                        placeholder={t(`global.lang`)}
                        isClearable
                        isLoading={lang.loading}
                        isDisabled={lang.loading}
                        getOptionLabel={option => option["name"]}
                        getOptionValue={option => option["name"]}
                        formatGroupLabel={option => option["name"]}
                        options={
                          lang.map(({ name }) => ({
                            name
                          }))
                        }
                        component={FormElements.Select}
                      />
                      <Field
                        name="name"
                        label={t(`${TRANSLATION_BASE}.name`)}
                        placeholder={t(`${TRANSLATION_BASE}.enter_name`)}
                        component={FormElements.Input}
                      />
                    </Col>
                    <Col md={12}>
                      <Field
                        name="price"
                        label={t(`${TRANSLATION_BASE}.price`)}
                        placeholder={t(`${TRANSLATION_BASE}.enter_price`)}
                        component={FormElements.Input}
                      />
                    </Col>
                    <Col md={12}>
                      <Field
                        name="discount"
                        label={t(`${TRANSLATION_BASE}.discount`)}
                        placeholder={t(`${TRANSLATION_BASE}.enter_discount`)}
                        component={FormElements.Input}
                      />
                    </Col>
                    <Col md={12}>
                      <Field
                        htmlType="textarea"
                        name="description"
                        label={t(`${TRANSLATION_BASE}.desc`)}
                        placeholder={t(`${TRANSLATION_BASE}.write_desc`)}
                        component={FormElements.Input}
                      />
                    </Col>
                  </Row>
                </ModalBody>
                <ModalFooter>
                  <button type="button" className="btn btn-secondary waves-effect" onClick={() => onClose()}>
                    {t("global.close")}
                  </button>
                  <button type="submit" className="btn btn-info waves-effect waves-light">
                    {t("global.save_changes")}
                  </button>
                </ModalFooter>
              </form>
            </Preloader>
          );
        }}
      </Formik>
    </Modal>
  );
};
